<template>
  <v-layout column class="mx-2">
    <vue-snotify></vue-snotify>
    <v-card class="mx-auto" flat>
      <v-card-title class="headline font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
      </v-card-title>
      <v-divider class="secondary"></v-divider>

      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
            <span class=" grey--text text--darken-1">
              ThinkAir is undergoing a digital transformation journey ,
              investing in a new technology platform to bring schools fantastic
              digital shows and teacher’ resources to support the STEAM
              curriculum. You will be able to have a theatre experience in your
              classroom. But remember you can also visit ThinkAir for the
              real theatre experience as well as interact with all of our
              amazing STEM related exhibits.
            </span>
            <v-form ref="details" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model="Form.fullName"
                    outlined
                    label="Name"
                    append-icon="icons8-male-user-3"
                    hide-details="auto"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="Form.email"
                    outlined
                    label="Email"
                    append-icon="icons8-envelope-3"
                    hide-details="auto"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-col>
                <!-- The Marketing checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="Form.marketingCheckbox"
                    class="mx-2"
                    label="Marketing Checkbox"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                    I consent to ThinkAir contacting me via email in line
                    with the
                    <a
                      href="https://www.techniquest.org/terms-conditions/privacy-policy/marketing/"
                      target="_blank"
                    >
                      Marketing Privacy</a
                    >
                  </p>
                </v-col>
                <!-- The Data processing Checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="Form.dataProcessingCheckbox"
                    class="mx-2"
                    label="Data Processing Checkbox"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Required']"
                    required
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                    By checking this box you agree with the storage and handling
                    of your data by this website in accordance with our
                    <span
                      @click="dialog = true"
                      class="primary--text text-decoration-underline"
                      style="cursor: pointer !important"
                      >Privacy Policy</span
                    >
                  </p>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
            <span class=" grey--text text--darken-1">
              ThinkAir is undergoing a digital transformation journey ,
              investing in a new technology platform to bring schools fantastic
              digital shows and teacher’ resources to support the STEAM
              curriculum. You will be able to have a theatre experience in your
              classroom. But remember you can also visit ThinkAir for the
              real theatre experience as well as interact with all of our
              amazing STEM related exhibits.
            </span>
            <v-form ref="password" v-model="valid1" lazy-validation>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="userPassword"
                    outlined
                    label="Password"
                    :append-icon="show ? 'icons8-eye' : 'icons8-invisible'"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                    :rules="passwordRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model.trim="confirmPassword"
                    outlined
                    label="Confirm Password"
                    :append-icon="show1 ? 'icons8-eye' : 'icons8-invisible'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="[confirmRules, passwordConfirmationRule]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="3">
          <div class="pa-4 text-center" v-if="accountCreated === true">
            <h3 class="title font-weight-light mb-2">
              Welcome to ThinkAir
            </h3>
            <span class="caption grey--text">Thanks for signing up!</span>
          </div>
          <div class="pa-4 text-center" v-else>
            <h3 class="title font-weight-light mb-2">Something went wrong</h3>
            <span class="caption grey--text">Try again!</span>
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="step === 1" class="px-8" @click="step--">
          Back
        </v-btn>

        <v-btn
          v-if="step === 1"
          class="px-8"
          color="primary"
          depressed
          @click="validateDetails()"
          v-on:keyup.enter="validateDetails()"
        >
          Next
        </v-btn>
        <v-btn
          v-if="step === 2"
          class="px-8"
          color="primary"
          depressed
          @click="signUp"
          v-on:keyup.enter="signUp()"
        >
          Sign Up
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          Privacy and Terms & Conditions
          <v-spacer></v-spacer>

          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-toolbar>

        <PrivacyTermsConditions />
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">
            Read
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import PrivacyTermsConditions from "../page-components/PrivacyTermsConditions.vue";

export default {
  name: "RegisterAdmin",
  components: {
    PrivacyTermsConditions,
  },
  data: () => ({
    step: 1,
    dialog: false,
    valid: true, // details form valid
    valid1: true, // password form valid
    show: false, // show/hide password
    show1: false, // show/hide confirm password
    termsAgree: false,
    Form: {
      fullName: "",
      email: "",
      telephoneNumber: "",
      accountCreatedAt: "",
      position: "Admin",
      userTypeId: "100", // set to 10 for normal user
      emailVerified: false,
      modifiedTimestamp: "",
      marketingCheckbox: false,
      dataProcessingCheckbox: false,
      suspendUser:false,
    },
    userPassword: "",
    confirmPassword: "",
    accountCreated: true, // show thank you/ try gain message at the end
    validEmailDomains: ["vindico.net", "digitickets.co.uk", "techniquest.org"], // validate email address
    //validation rules
    nameRules: [(v) => !!v || "Full name is required"],
    confirmRules: [(v) => !!v || "Confirm password required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [(v) => !!v || "Password is required"],
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "SIGN UP";
        case 2:
          return "CREATE A PASSWORD";
        default:
          return "ACCOUNT CREATED";
      }
    },
    passwordConfirmationRule() {
      return () =>
        this.userPassword === this.confirmPassword || "Password must match";
    },
  },
  methods: {
    validateDetails() {
      var emailDomain = this.Form.email.substring(
        this.Form.email.indexOf("@") + 1
      );
      // console.log(emailDomain);
      if (this.$refs.details.validate()) {
        if (this.validEmailDomains.includes(emailDomain)) {
          this.step++;
        } else {
          this.$snotify.error(
            "You need an organisation email in order to continue."
          );
        }
      } else {
        //   console.log("not valid");
        this.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    goToHome() {
        this.$router.push("/").catch((err) => {});
    },
    signUp() {
      this.Form.accountCreatedAt = this.$moment().toISOString();
      if (this.$refs.password.validate()) {
        this.step++;

        var t = this;
        //create profile
        t.$firebase.auth
          .createUserWithEmailAndPassword(t.Form.email, t.userPassword)
          .then((user) => {
            t.Form.emailVerified = false;
            t.Form.passwordResetCode = "0"; //
            t.Form.emailVerificationCode = "1234";
            t.Form.email = t.Form.email.toLowerCase();

            //add to users table
            t.$firebase.db
              .collection("users")
              .doc(user.user.uid)
              .set(t.Form)
              .then((Result) => {})
              .catch((err) => {
                //console.log(err);
              });
            t.accountCreated = true;
            this.$snotify.success("Your account was created."); // notification component

            //send verification email
            var user = t.$firebase.auth.currentUser;

            user
              .sendEmailVerification()
              .then(function() {
                // Email sent.
              })
              .catch(function(error) {
                // An error happened.
                //  console.log("verif email: " + error);
              });
            //log user out
            setTimeout(function() {
              t.goToHome();
            }, 1500);
          })
          .catch((err) => {
            t.accountCreated = false;
            //  console.log("error: " + err);
            this.$snotify.error(err);
          });
      } else {
        this.accountCreated = false;
        // console.log("not valid");
        this.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
  },
};
</script>
